<app-sub-page class="width-100" navBackRoute="/settings">
  <div class="flex width-100 column flex-1 flex-between" style="max-width: 800px">
    <div class="flex width-100 column flex-1 gap-05">
      <div
        class="flex width-100 flex-between align-center rounded-sm"
        style="background-color: var(--surface-50); padding: 0.5rem"
      >
        <div class="text-title">Available PVDs</div>
        @if (pvdValue$ | async; as pvdValue) { @if (pvdValue.isLoading && !pvdValue.response) {
        <p-skeleton width="80%" height="100%" />
        } @else {
        <input [value]="pvdValue.response?.availablePVDs" type="number" (keyup)="onKeyUp($event)" inputmode="numeric" />
        } }
      </div>
      <div style="font-size: 0.9rem; color: var(--text-color-secondary); padding: 0 1rem">
        The total available pvds are an assumed value initially. If you feel as though they are not accurate, this is
        where you can change them.
      </div>
    </div>
    <app-button
      label="Save"
      [outlined]="globalService.theme() === 'dark'"
      [disabled]="!hasChanges"
      (click)="savePvds()"
    />
  </div>
</app-sub-page>
